import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/physical-security/ptz/ai-ptz.png";
import type { Product } from "../../types";
import { ptz as productListGroupPTZ } from "../product-list-groups/ptz";

export const aiPtzIndustrial: Product = {
  id: "aiPtzIndustrial",
  productTitle: "AI PTZ Industrial",
  description: "aiPtz.description",
  isNew: true,
  techspecsPath: [SiteId.TechSpecs, `/unifi/cameras-nvrs/uvc-ai-ptz`],
  storePathParts: {
    productSlug: "uvc-ai-ptz",
    category: "cameras-ptz",
  },
  image: { src: image, width: 200, height: 140 },
  productListGroup: productListGroupPTZ,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '207 x 223.7 x 341.3 mm\n(8.2 x 8.8 x 13.4")',
      },
    },
    {
      propertyId: "cameraResolution",
      value: { type: "string", value: "4K" },
    },
    {
      propertyId: "imageSensor",
      value: { type: "string", value: '1/1.8" 8MP' },
    },
    {
      propertyId: "fieldOfView",
      value: {
        type: "translation",
        value: "aiPtz.fov",
      },
    },
    {
      propertyId: "nightVision",
      value: { type: "string", value: "100 m (328 ft)" },
    },
    {
      propertyId: "opticalZoom",
      value: {
        type: "translation",
        value: "aiPtz.opticalZoom",
      },
    },
    {
      propertyId: "smartDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "enhancedDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "licensePlateRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "aiRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "cameraAudio",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "outdoorReady",
      value: { type: "string", value: "IP66" },
    },
    {
      propertyId: "faceRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "tamperResistance",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "deployment",
      value: { type: "string", value: "PoE++" },
    },
  ],
};
